module.exports = __webpack_public_path__ + "img/opportunity_house_black.217f18e7.svg";